import styled from "styled-components";

export const TreeViewContainer = styled.div`
  width: 100%;
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const VaultItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
`;

export const FolderItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px 6px 60px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
`;

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  svg {
    color: #666;
    font-size: 20px;
  }
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-right: 8px;
`;

export const ExpandIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  svg {
    color: #666;
    font-size: 20px;
  }

  &:hover svg {
    color: #333;
  }
`;

export const ItemLabel = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 13px;
`;

